// hex转为rgb
export const hexToRgb = (hex: string) => {
  return (
    'rgb(' +
    parseInt('0x' + hex.slice(1, 3)) +
    ',' +
    parseInt('0x' + hex.slice(3, 5)) +
    ',' +
    parseInt('0x' + hex.slice(5, 7)) +
    ')'
  )
}

// hex转为rgba
export const hexaToRgba = (hexa: string) => {
  const alpha = getOpacity(hexa)
  return (
    'rgb(' +
    parseInt('0x' + hexa.slice(1, 3)) +
    ',' +
    parseInt('0x' + hexa.slice(3, 5)) +
    ',' +
    parseInt('0x' + hexa.slice(5, 7)) +
    ',' +
    alpha +
    ')'
  )
}

// rgb + alpha转rgba
export const rgbToRgba = (rgb: string, alpha: number) => {
  return rgb.replace(')', `,${alpha})`)
}

// 合法alpha
export const normalizeAlpha = (alpha: number): number => {
  alpha = Math.round(alpha * 100) / 100
  return alpha > 1 ? 1 : alpha < 0 ? 0 : alpha
}
// 合法hexa
export const normalizeHexaUnit = (value: string): boolean => {
  const trimmedValue = value.trim()
  if (/^#[0-9a-fA-F]+$/.test(trimmedValue)) {
    return [4, 5, 7, 9].includes(trimmedValue.length)
  }
  return false
}

// hex转hexa
export const getHexOpacityColor = (color: string, opacity: number) => {
  const nowColor = color.slice(1, 7).toUpperCase()
  // 四舍五入
  let num = Math.round(255 * opacity)
  let str = ''
  const arrHex = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F'
  ]
  // 十六进制数组
  while (num > 0) {
    const mod = num % 16
    num = (num - mod) / 16
    str = arrHex[mod] + str
  }
  if (str.length === 1) str = '0' + str
  if (str.length === 0) str = '00'
  return `#${nowColor + str}`
}

// #ffffffff 获取透明度
export const getOpacity = (color: string) => {
  return Number((parseInt('0x' + color.slice(7, 9)) / 255).toFixed(2))
}
